import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { formatTypes } from '@zipari/shared-ds-util-format';
import { FormattingService } from '../../shared/services/formatting.service';
import { getValue } from '../../shared/utils/get-value';
import { LinkListItem } from '../../chords/link-list/link-list.model';
import {
  AccountCardConfig,
  AccountCardDataModel,
} from './account-amount-card.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'account-amount-card',
  templateUrl: './account-amount-card.component.html',
  styleUrls: ['./account-amount-card.component.scss'],
})
export class AccountAmountCardComponent implements OnInit {
  @Input() config: AccountCardConfig;
  @Input() enablePayButton = false;
  @Input() data: AccountCardDataModel;

  @Output() makePaymentFromAccount = new EventEmitter();
  @Output() accountLinkClicked = new EventEmitter();

  constructor(private formatService: FormattingService) {}

  ngOnInit(): void {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config as AccountCardConfig;
    this.data = data as AccountCardDataModel;
  }

  get amount(): string {
    const totalAmountAvailable = getValue(this.data, this.config.amount.prop);

    return this.formatService.restructureValueBasedOnFormat(
      totalAmountAvailable,
      {
        format: formatTypes.CURRENCY,
      },
    );
  }

  get amountTypeDetail(): string {
    return getValue(this.data, this.config.amountType.prop)?.toUpperCase();
  }

  get documentDescription(): string {
    return getValue(this.data, this.config.documentDescription.prop);
  }

  makePaymentFromAccountClicked() {
    this.makePaymentFromAccount.emit();
  }

  linkClicked(event: LinkListItem) {
    this.accountLinkClicked.emit(event);
  }
}
